// extracted by mini-css-extract-plugin
module.exports = {"fadeInSection":"fadeup_fadeInSection__2Uqnc","fade":"fadeup_fade__XdKob"};